<div class="title-wrapper">
  <div class="col-m-12">
    <h2>{{pageTitle}}</h2>
  </div>
</div>
